import React from 'react';
import PropTypes from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

// Cotação / contratação / credenciamento / audiência — notícia simplificada:
// título + data + descrição + texto livre (blocos padrão Volto) + anexos.
// Sem hero rico, sem share, sem tempo de leitura, sem "Veja Também".

// timeZone fixo (America/Sao_Paulo) é essencial: sem ele, getDate()/getMonth()
// usam o fuso do ambiente — Node SSR (UTC) e navegador (BRT) divergem em datas
// gravadas perto da meia-noite UTC, causando hydration mismatch (React #418).
const formatDateLong = (iso) => {
  if (!iso) return null;
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'America/Sao_Paulo',
    }).format(new Date(iso));
  } catch {
    return null;
  }
};

const ContractView = ({ content }) => {
  const dateLong = formatDateLong(content?.effective || content?.created);
  const eyebrow =
    (Array.isArray(content?.subjects) && content.subjects[0]) || 'Contratação';
  const description = (content?.description || '').trim();
  // Evita repetir o título quando a descrição é idêntica (caso comum nos editais).
  const showDescription =
    description && description !== (content?.title || '').trim();

  // Renderiza o corpo: texto livre (slate) + anexos. Esconde o que já está no header
  // ou que pertence só à notícia rica.
  const blocksData = content?.blocks || {};
  const HIDDEN_TYPES = new Set([
    'title', 'description', 'newsitem-meta', 'eyebrow',
    'featured-image', 'agsusImagemPrincipal',
  ]);
  const layout = (content?.blocks_layout?.items || []).filter((id) => {
    const t = blocksData[id]?.['@type'];
    return !HIDDEN_TYPES.has(t);
  });
  const filteredContent = {
    ...content,
    blocks: blocksData,
    blocks_layout: { items: layout },
  };

  return (
    <article className="ag-contract-view">
      <header className="ag-contract-view__header">
        <div className="ag-contract-view__header-inner container">
          <span className="ag-contract-view__eyebrow">{eyebrow}</span>
          <h1 className="ag-contract-view__title">{content.title}</h1>
          {dateLong && (
            <div className="ag-contract-view__date">
              <strong>Publicado</strong> {dateLong}
            </div>
          )}
        </div>
      </header>

      <div className="container">
        {showDescription && (
          <p className="ag-contract-view__lead">{description}</p>
        )}
        <div className="ag-contract-view__body">
          <RenderBlocks content={filteredContent} />
        </div>
      </div>
    </article>
  );
};

ContractView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    effective: PropTypes.string,
    created: PropTypes.string,
    subjects: PropTypes.arrayOf(PropTypes.string),
    blocks: PropTypes.object,
    blocks_layout: PropTypes.object,
  }).isRequired,
};

export default ContractView;
